import { decode } from '@lucidlink/sdk';
import { constructGuestLink, extractLinkDataFromUrl, } from '#features/guest-links';
import { appRoutes, isInTwoFactorAuthenticationLoginFlow } from '#services';
export const guestPrivateRoutePredicate = ({ currentUser, location, }) => {
    const { currentOrigin, fullHash, pathname } = extractLinkDataFromUrl(location);
    const navigatedFrom = pathname + fullHash;
    let workspaceId;
    if (!navigatedFrom ||
        !fullHash ||
        isInTwoFactorAuthenticationLoginFlow(currentUser)) {
        return {
            isSuccess: false,
            navigateTo: appRoutes.login(),
        };
    }
    const [_, _linkType, linkFormatVersion, encodedFileData, encodedEncryptedFileName,] = pathname.split('/');
    const constructedUrl = constructGuestLink({
        currentOrigin,
        encodedEncryptedFileName,
        encodedFileData,
        linkFormatVersion,
    });
    try {
        workspaceId = decode(new URL(constructedUrl)).workspaceId;
    }
    catch (decodeError) {
        return {
            isSuccess: false,
            navigateTo: appRoutes.login(),
            navigatedFrom,
        };
    }
    if (!currentUser) {
        return {
            isSuccess: false,
            navigateTo: `/login-guest/${workspaceId}${fullHash}`,
            navigatedFrom,
        };
    }
    if (!currentUser?.emailVerified) {
        return {
            isSuccess: false,
            navigateTo: '/verify-account-guest',
            navigatedFrom,
        };
    }
    return { isSuccess: true };
};
